// extracted by mini-css-extract-plugin
export default {"children":"Layout_children__qEqZa"};